import TestingHubPopup from "../../testing/TestingHubPopup";

export default function TestingHubApp({ onClose }) {
  return <TestingHubPopup onClose={onClose} />;
}
